export const LocalStorageKeys = {
  DATE_SELECTED: "date-selected",
  TIMELINE_TIME_RANGE: "timeline-time-range",
  DEFAULT_SELECTED_GROUPS: "default-selected-groups",
  VERSION: "version",
  NOTIFICATIONS: "notifications",
  PAGE_SIZE: "page-size"
};
